import React from "react";

export default function Tickets() {
  return (
    <div style={{ width: "100%", height: "calc(100vh - 64px)" }}>
      <iframe
        src="https://datastudio.google.com/embed/reporting/56b3aa3b-d4bc-4034-b53a-ad2209f62540/page/YzqcF"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  );
}